function ConditionAlertListController(ConditionAlertService, arraySortService, $uibModal, $scope) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.alerts = [];
    ctrl.data = [];
    ctrl.loadAlerts();
    ctrl.sortType = 'ALERT_TIME';
    ctrl.sortReverse = false;
    ctrl.showActive = true;
    ctrl.showReset = true;
    $scope.$emit('gridlet-register-export', {
      excel: () => ctrl.exportToExcel(),
      csv: () => ctrl.exportToCsv(),
    });
  };

  ctrl.loadAlerts = async () => {
    ctrl.data = await ConditionAlertService.getAlerts();

    ctrl.data.forEach(item => {
      if (!ctrl.alerts.includes(item)) {
        ctrl.alerts.push(item);
      }
    });
    ctrl.filter();
    arraySortService.sortArrayWithKey(ctrl.alerts, 'alertTime', true);

  };

  ctrl.changeActive = () => {
    ctrl.showActive = !ctrl.showActive;
    ctrl.filter();
  };

  ctrl.changeReset = () => {
    ctrl.showReset = !ctrl.showReset;
    ctrl.filter();
  };

  ctrl.filter = () => {
    ctrl.alerts = [];
    ctrl.data.forEach(item => {
      if (ctrl.alerts.includes(item)) return;

      const activeEvent = !item.resetTime;
      if (activeEvent && ctrl.showActive || !activeEvent && ctrl.showReset) {
        ctrl.alerts.push(item);
      }
    });
    sortEvents();
  };

  ctrl.setSortType = column => {
    ctrl.sortReverse = (ctrl.sortType === column) ? !ctrl.sortReverse : false;
    ctrl.sortType = column;
    sortEvents();
  };

  const sortEvents = () => {
    switch (ctrl.sortType) {
      case "CAR_ID": {
        arraySortService.sortArrayWithInnerValue(ctrl.alerts, 'asset', 'carId', ctrl.sortReverse);
        break;
      }
      case "CATEGORY": {
        arraySortService.sortArrayWithInnerValue(ctrl.alerts, 'asset', 'category', ctrl.sortReverse);
        break;
      }
      case "ASSET_NAME": {
        arraySortService.sortArrayWithInnerValue(ctrl.alerts, 'asset', 'name', ctrl.sortReverse);
        break;
      }
      case "ALERT_TYPE": {
        arraySortService.sortArrayWithKey(ctrl.alerts, 'alertType', ctrl.sortReverse);
        break;
      }
      case "ALERT_TIME": {
        arraySortService.sortArrayWithKey(ctrl.alerts, 'alertTime', ctrl.sortReverse);
        break;
      }
      case "RESET_TIME": {
        arraySortService.sortArrayWithKey(ctrl.alerts, 'resetTime', ctrl.sortReverse);
        break;
      }
      default: {
        console.log("Invalid choice");
        break;
      }
    }
  };

  ctrl.onAlertClick = alert => {
    ctrl.openConditionGraphModal(alert);
  };

  ctrl.openConditionGraphModal = alert => {
    const modalInstance = $uibModal.open({
      component: 'conditionGraphModal',
      windowClass: 'subSystemWindow',
      resolve: {
        alert: function () {
          return alert;
        },
      },
    });

    modalInstance.result.then(() => {
    }, () => {
    });
  };

}

angular
  .module('gridlets.module')
  .controller('ConditionAlertListController', ConditionAlertListController);